import { createSelector } from 'reselect';
export const selectArticle = state => state.articleContentInfo.article;
export const selectArticleLanguage = createSelector(selectArticle, article => article.values.hs_language);